import React from "react";
import { Form } from "react-bootstrap";
import AsyncSelect from "react-select/async";
import { MenuItem, MenuItems } from "../../../../../components/@types";
import { getClassificationMenuItems } from "../menuItems";
import { CUSTOM_SELECT_CLASSNAMES, TEST_ID_KEYS } from "../consts";
import { CustomInput } from "../files/components/CustomInput";
import { CustomClassificationOption } from "../files/components/CustomOption";
import { CustomDropdownIndicator } from "../files/components/CustomDropdownIndicator";
import { CustomClassificationMultiValueContainer } from "../files/components/CustomMultiValueContainer";
import { CustomNoOptionsMessage } from "../files/components/CustomNoOptionMessage";
import { CustomClassificationSingleValue } from "../files/components/CustomSingleValue";

interface IClassificationMultiSelectProps {
  isMulti: true;
  value?: MenuItems;
  onChange: (value: MenuItems) => void;
}

interface IClassificationSingleSelectProps {
  isMulti: false;
  value?: MenuItem;
  onChange: (value: MenuItem) => void;
}

type IClassificationSelectProps =
  | IClassificationMultiSelectProps
  | IClassificationSingleSelectProps;

const ClassificationSelect = ({
  isMulti,
  value,
  onChange
}: IClassificationSelectProps) => {
  const valueIsNotEmpty = isMulti ? !!value?.length : !!value?.value;

  return (
    <Form.Group>
      <Form.Label className={"form-text--important"}>
        Classification:
      </Form.Label>
      <div data-testid={"classification-select"}>
        <AsyncSelect<MenuItem, typeof isMulti>
          isMulti={isMulti}
          isSearchable={false}
          isClearable
          cacheOptions
          defaultOptions
          loadOptions={(
            inputValue: string,
            callback: (options: MenuItems) => void
          ) =>
            callback(
              getClassificationMenuItems().filter(item =>
                item.label.toLowerCase().includes(inputValue.toLowerCase())
              )
            )
          }
          testIdKey={TEST_ID_KEYS.CLASSIFICATION}
          classNames={CUSTOM_SELECT_CLASSNAMES}
          value={valueIsNotEmpty ? value : null}
          onChange={onChange}
          closeMenuOnSelect
          placeholder="Select from List"
          maxMenuHeight={200}
          menuShouldScrollIntoView={false}
          openMenuOnClick
          components={{
            Input: CustomInput,
            Option: CustomClassificationOption,
            DropdownIndicator: CustomDropdownIndicator,
            MultiValueContainer: CustomClassificationMultiValueContainer,
            NoOptionsMessage: CustomNoOptionsMessage,
            SingleValue: CustomClassificationSingleValue
          }}
        />
      </div>
    </Form.Group>
  );
};

export default ClassificationSelect;
